import Service from '@ember/service';

import { service } from '@ember/service';
import { cached } from '@glimmer/tracking';

import { get } from 'rise-ui/utils/object.js';
import { or, readOnly } from 'rise-ui/utils/object/computed.js';
import { mapBy, truth } from 'rise-ui/utils/object/computed/array.js';
import { qpDateRangeIsValid } from 'rise-ui/utils/qp-date.js';

export default class TimeSeriesOutputsService extends Service {
  @service('time-series/selected-locations') timeSeriesLocations;
  @service('time-series/params') timeSeriesParams;
  @service('time-series/dates') timeSeriesDates;

  allowInvalidOutputs = true;

  @cached get _outputs() {
    const items = [];
    const modelRuns = [];
    const { hasItem, hasModelRun } = this.timeSeriesParams;
    const { itemDates, modelRunDates } = this.timeSeriesDates;
    const { allowInvalidOutputs } = this;
    const outputs = (this.timeSeriesLocations.locations.value || [])
      .reduce((outputs, location) => {
        get(location, 'catalogRecords').forEach(record => {
          record.items.forEach(item => {
            const availableDates = {
              from: item.temporalStartDate,
              to: item.temporalEndDate,
            }
            if (item.isModeled) {
              const itemModelRuns = item.modelRuns;
              itemModelRuns.forEach(modelRun => {
                if (hasModelRun[modelRun.id]) {
                  const dates = modelRunDates[modelRun.id];
                  const isValid = qpDateRangeIsValid(availableDates, dates);
                  if (allowInvalidOutputs || isValid) {
                    modelRun.$hasInvalidDates = !isValid;
                    modelRuns.push(modelRun);
                    outputs.push(modelRun);
                  }
                }
              });
            } else {
              if (hasItem[item.id]) {
                const dates = itemDates[item.id];
                const isValid = qpDateRangeIsValid(availableDates, dates);
                if (allowInvalidOutputs || isValid) {
                  item.$hasInvalidDates = !isValid;
                  items.push(item);
                  outputs.push(item);
                }
              }
            }
          });
        });
        return outputs;
      }, []);
    return {
      outputs,
      items,
      modelRuns,
    };
  }

  @readOnly('_outputs.outputs') outputs;
  @or('outputs.length', or.value(0)) count;
  @readOnly('_outputs.items') items;
  @readOnly('_outputs.modelRuns') modelRuns;
  @mapBy('items', 'id') itemIds;
  @mapBy('modelRuns', 'id') modelRunIds;
  @truth('itemIds') hasItem;
  @truth('modelRunIds') hasModelRun;

  @readOnly('timeSeriesLocations.locations.isPending') isLoading;
}
